var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37346 4.71462C9.82184 4.93035 9.82184 5.56884 9.37346 5.78457L2.25706 9.20844C1.86292 9.39808 1.406 9.11086 1.406 8.67347V1.82572C1.406 1.38833 1.86292 1.10111 2.25706 1.29074L9.37346 4.71462Z",
    fill: "white",
    stroke: "#A1A1A1",
    strokeWidth: 1.31249
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.585969d65566a2390a7c73c806ae2050.svg";
export { ForwardRef as ReactComponent };